import { v3 } from "../short3";
import * as Textures from "../Textures";
import * as Maths3 from "../Maths3";
import { simpleSizeFormatter } from "./rulers/simpleSizeFormatter";

import * as _ from "lodash";
import { ArrowHelper, Object3D, Quaternion, Vector3 } from "three";

declare const STAGE: any;

/**
 * zeigt ein Koordinatenkreuz wie THREE.AxisHelper, allerdings mit Beschriftung der Achsen ('x' und Einheit)
 */
export class OcAxisHelper extends Object3D {
  constructor(
    size: number = 1,
    formatter: (size: number) => string = simpleSizeFormatter(
      _.defaultsDeep({ fixed: 1 }, STAGE.settings.ruler),
    ),
  ) {
    super();

    const addAxis = (
      label: string,
      color: number,
      direction: Vector3,
      offset: Vector3,
      labelQuat: Quaternion,
    ) => {
      this.add(new ArrowHelper(direction, v3(0, 0, 0), size, color));

      const sprite = Textures.createTextPlane(label + " (" + formatter(size) + ")", {
        backgroundColor: "transparent",
        orginalHeight: 0.03,
        quaternion: Maths3.quaternion.x270.clone().multiply(labelQuat),
      });
      sprite.position.add(direction.clone().normalize().multiplyScalar(size).add(offset));
      this.add(sprite);
    };

    let o = 0.1;
    addAxis("x", 0xff0000, v3(1, 0, 0), v3(o, o, 0), Maths3.quaternion.x90);
    addAxis(
      "y",
      0x00ff00,
      v3(0, 1, 0),
      v3(o * 0.2, o, o * 0.2),
      Maths3.quaternion.x90.clone().multiply(Maths3.quaternion.y45),
    );
    addAxis(
      "z",
      0x0000ff,
      v3(0, 0, 1),
      v3(0, o, o),
      Maths3.quaternion.x90.clone().multiply(Maths3.quaternion.y90),
    );
  }
}
